import { EntityApi } from "../../services/ApiPlatform";
import { FinalResponse } from "../../services/ApiPlatform/models";

export abstract class DashboardApi extends EntityApi {
    protected static API_DASHBOARD_TRANSACTION_STAT =
        "/api/dashboard/get-transaction-stat";

    public static async dashboardTransactionStat<R>(): Promise<
        FinalResponse<R | null>
    > {
        return this.getRequest(this.API_DASHBOARD_TRANSACTION_STAT);
    }
}
